// import readXlsxFile from 'read-excel-file';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { Container, Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import EarningList from './EarningList';
import { withAuthorization } from '../Session';

class Earning extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        
    }
    render() {
        return (
            <Container>
                <Row>
                    <h5 style={{ marginLeft: '1rem' }}>View Store Earning</h5>
                </Row>
                <EarningList />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Earning);
